export default __webpack_public_path__ + "static/media/CNo.36-2.0c365df1.jpg";